<template>
  <div>
      행사 참여자 관리
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>